import { isPast, parseISO } from "date-fns";

import { routes } from "@/features/shared/navigation";
import { AccessToken } from "@/lib/api";
import { throwResponseIfInvalid } from "@/features/shared/utils";

import { USER_ROLES } from "./consts";

export const hasAuthTokenExpired = (token?: AccessToken) => {
  if (!token || !token.expires_at) return true;

  return isPast(parseISO(token.expires_at));
};

export const convertQueryParamsToState = (queryParams: Record<string, string>) => {
  const state = Object.keys(queryParams)
    .map((key) => `${key}:${queryParams[key]}`)
    .join(";");

  return btoa(state);
};

export const convertStateToQueryParams = (encodedString: string) => {
  return atob(encodedString)
    .split(";")
    .reduce((queryParams: Record<string, string>, param: string) => {
      const [key, value] = param.split(":");

      queryParams[key] = value;
      return queryParams;
    }, {});
};

export const appendStateToLoginUrl = (state: string) => {
  return `${routes.auth.login}?state=${state}`;
};

export const userHasRequiredRoles = (userRoles: string[], requiredRoles: string[]) => {
  return requiredRoles.every((role) => userRoles.includes(role));
};

export const assertAdminRole = (userRoles: string[]) => {
  throwResponseIfInvalid(
    userHasRequiredRoles(userRoles, [USER_ROLES.admin]),
    "Unauthorized",
    403,
  );
};
